export default __webpack_public_path__ + "static/media/iPadSS11.582d9a36.png";